var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"auth-modal","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"pb-4"},[_c('logo',{staticClass:"mb-4 mt-4",attrs:{"dark":true}})],1),_c('auth-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }